export const FE_NOTIFICATIONS_REQUEST = "FE_NOTIFICATIONS_REQUEST";
export const FE_NOTIFICATIONS_FAILURE = "FE_NOTIFICATIONS_FAILURE";
export const FE_NOTIFICATIONS_SUCCESS = "FE_NOTIFICATIONS_SUCCESS";
